import React from "react";
import { Typography, Table } from "antd";
import { useIntl } from "react-intl";
import Date from "../../../components/tables/Date";
const { Title, Text } = Typography;

const Events = (props) => {
  const { events } = props;
  const intl = useIntl();

  const columns = [
    {
      title: intl.formatMessage({
        id: "app.trom.index",
      }),
      dataIndex: "index",
      render(text) {
        return <Text>{text}</Text>;
      },
      width: "70px",
    },
    {
      title: intl.formatMessage({
        id: "app.trom.start",
      }),
      dataIndex: "start",
      render(text) {
        return <Date text={text} format={"DD/MM/YYYY"} />;
      },
      width: "130px",
    },
    {
      title: intl.formatMessage({
        id: "app.trom.end",
      }),
      dataIndex: "end",
      render(text) {
        return <Date text={text} format={"DD/MM/YYYY"} />;
      },
      width: "130px",
    },
    {
      title: intl.formatMessage({
        id: "app.trom.sum",
      }),
      dataIndex: "sum",
      render(text) {
        return <Text>{text}</Text>;
      },
      width: "90px",
    },
    {
      title: intl.formatMessage({
        id: "app.trom.names",
      }),
      dataIndex: "names",
      render(text) {
        return <Text>{text}</Text>;
      },
      width: "100%",
      ellipsis: true,
    },
  ];
  const total =
    Math.round(events.reduce((n, { sum }) => n + sum, 0) * 100) / 100;
  const text = "סה״כ שעות:";
  const totalText = `${text} ${total}`;
  return (
    <div>
      <Title level={5}>שעות טרום שניתנו</Title>
      <div>
        <Table dataSource={events} columns={columns} pagination={false} />
      </div>
      <Title style={{ paddingTop: "20px" }} level={5}>
        {totalText}
      </Title>
      <div />
    </div>
  );
};

export default Events;
